import React, { useEffect } from 'react';
import axios, { AxiosError } from 'axios';
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';

let isRefreshing = false;
let failedRequestQueue: Array<any> = [];

function getAPIURL() {
  if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    return 'https://api.qa.oqdigital.com';
  } else if (
    window.location.hostname === 'oqpwahom.web.app' ||
    window.location.hostname === 'oqpwahom.firebaseapp.com'
  ) {
    return 'https://api.qa.oqdigital.com';
  } else {
    return 'https://api3.oqdigital.com';
  }
}

function getEnv() {
  const urlApi = getAPIURL();
  if (urlApi === 'https://api.qa.oqdigital.com') {
    return 'nestjs';
  } else {
    return 'nodejs';
  }
}

const api = axios.create({
  baseURL: getAPIURL(),
});

export const ApiProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { signOut, client } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    api.interceptors.response.use(
      (response) => {
        return response;
      },
      (error: AxiosError<any, any>) => {
        if (error.response?.status === 401) {
          const originalConfig: any = error.config;
          const { refresh }: any = error.response.config.headers;

          if (!isRefreshing) {
            isRefreshing = true;
            const parameters = {
              refresh_token: refresh,
              searchFunctionality: 'refreshToken',
            };

            api
              .post('/search', parameters)
              .then((response) => {
                const { accessToken, refreshToken } = response.data.data;
                api.defaults.headers.common['Authorization'] =
                  `OQVCQUER ${accessToken}`;
                api.defaults.headers.common['refresh'] = refreshToken;

                failedRequestQueue.forEach((request) =>
                  request.onSuccess(accessToken, refreshToken)
                );
                failedRequestQueue = [];
              })
              .catch((error) => {
                failedRequestQueue.forEach((request) =>
                  request.onFailure(error)
                );
                failedRequestQueue = [];
              })
              .finally(() => {
                isRefreshing = false;
              });
          }

          return new Promise((resolve, reject) => {
            failedRequestQueue.push({
              onSuccess: (token: string, refresh: string) => {
                originalConfig.headers['Authorization'] = `OQVCQUER ${token}`;
                originalConfig.headers['refresh'] = refresh;
                resolve(api(originalConfig));
              },
              onFailure: (error: AxiosError) => {
                signOut();
                navigate(`/_/${client.clientUrl}`);
                reject(error);
              },
            });
          });
        }
        throw error;
      }
    );
  }, []);

  return <>{children}</>;
};

export { api, getAPIURL, getEnv };
